import React from 'react';
import { DataRepository } from '../components/data-repository';
import { ViewContainer } from '../components/view-container';
import { DynamicFetcher } from '../components/dynamic-fetcher';

export const FormContent = () => (
  <>
    <DynamicFetcher />
    <DataRepository />
    <ViewContainer />
  </>
);
